
class CannedResponseGroup {
  constructor(name) {
    this.name = name;
    this.data = [];
  }
}

export default CannedResponseGroup;
